import { render, staticRenderFns } from "./BaseQuestionType.vue?vue&type=template&id=d9ad0318&"
import script from "./BaseQuestionType.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9ad0318')) {
      api.createRecord('d9ad0318', component.options)
    } else {
      api.reload('d9ad0318', component.options)
    }
    module.hot.accept("./BaseQuestionType.vue?vue&type=template&id=d9ad0318&", function () {
      api.rerender('d9ad0318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseQuestionType.vue"
export default component.exports